var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelClassGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hotel_class"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_472_2548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.392944,
    width: 33.2141,
    height: 33.2141,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_472_2548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotel_class_2",
    d: "M10.6877 26.0654C10.4695 26.2375 10.2428 26.2446 10.0078 26.0867C9.77265 25.9288 9.69502 25.715 9.77487 25.4453L11.4915 19.7898L7.1667 16.676C6.92542 16.5092 6.84779 16.291 6.93382 16.0213C7.01988 15.7516 7.20663 15.6168 7.49407 15.6168H12.886L14.6718 9.79368C14.718 9.64463 14.7912 9.53551 14.8914 9.46631C14.9916 9.39712 15.1021 9.36252 15.2227 9.36252C15.3434 9.36252 15.4538 9.39712 15.5541 9.46631C15.6543 9.53551 15.7275 9.64463 15.7736 9.79368L17.5595 15.6168H22.9514C23.2389 15.6168 23.4256 15.7516 23.5117 16.0213C23.5977 16.291 23.5201 16.5092 23.2788 16.676L18.954 19.7898L20.6706 25.4453C20.7505 25.715 20.6728 25.9288 20.4377 26.0867C20.2027 26.2446 19.976 26.2375 19.7577 26.0654L15.2227 22.6322L10.6877 26.0654ZM11.9013 23.436L15.2227 20.9023L18.5442 23.436L17.2986 19.215L20.4391 17.0007H16.5375L15.2227 12.7106L13.908 17.0007H10.0064L13.1469 19.215L11.9013 23.436ZM24.0905 26.0654L23.646 25.7327L22.1637 20.8704L25.8151 18.2516H26.3607C26.0094 18.2516 26.0289 18.3953 26.4192 18.6827C26.8096 18.9701 26.9107 19.1795 26.7226 19.3108L23.7924 21.4186L25.0114 25.4373C25.0734 25.6538 24.8659 25.7625 24.3886 25.7634C23.9113 25.7642 23.812 25.8649 24.0905 26.0654ZM19.6087 12.849L19.0232 10.9168L19.3586 9.82029C19.4047 9.67124 19.4779 9.56079 19.5781 9.48894C19.6784 9.41707 19.7888 9.38113 19.9095 9.38113C20.0301 9.38113 20.1406 9.4184 20.2408 9.49292C20.341 9.56744 20.4142 9.67657 20.4604 9.82029L21.3972 12.849H19.6087Z",
    fill: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelClassGray);
export default __webpack_public_path__ + "static/media/hotel_class_gray.56d9a6a5a3d3e849108a6a4ae96904b1.svg";
export { ForwardRef as ReactComponent };